/* Wont Miss Garage: behaviour for native sections. Delegated from the document, so it works the same whether a
   section was rendered on its own page or fetched and shown inside the tunnel app. */
(function () {
  if (window.__wmgNativeBound) return;
  window.__wmgNativeBound = true;
  // a button with no link jumps to the brief form on the same page, without touching the address bar
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-wmg-to-brief]');
    if (!a) return;
    e.preventDefault();
    var scope = a.closest('[data-native-slot]') || document;
    var form = scope.querySelector('#wmg-brief') || document.getElementById('wmg-brief');
    if (form && form.scrollIntoView) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-wmg-brief]')) return;
    e.preventDefault();
    var msg = form.querySelector('[data-wmg-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var hook = form.getAttribute('data-webhook') || ((window.WMG_SHOP || {}).webhook) || '';
    var payload = { type: 'source_request', page: location.pathname };
    var missing = [];
    form.querySelectorAll('[data-col]').forEach(function (el) {
      var v = String(el.value || '').trim();
      if (el.hasAttribute('required') && !v) missing.push(el.getAttribute('data-label') || el.getAttribute('data-col'));
      if (!v) return;
      var col = el.getAttribute('data-col');
      payload[col] = payload[col] ? payload[col] + '\n' + v : v;
      if (col === 'Name') payload.name = v;
      if (col === 'Email') payload.email = v;
      if (col === 'Phone') payload.phone = v;
    });
    var say = function (text, bad) { if (msg) { msg.textContent = text; msg.className = 'wmgn-form__msg' + (bad ? ' wmgn-form__msg--bad' : ''); } };
    if (missing.length) { say((form.getAttribute('data-missing') || 'Please fill in') + ': ' + missing.join(', '), true); return; }
    if (payload.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(payload.email)) { say(form.getAttribute('data-bad-email') || 'That email does not look right', true); return; }
    if (!hook) { say('The form is not connected yet (Theme settings, Google Sheets).', true); return; }
    if (btn) btn.disabled = true;
    say(form.getAttribute('data-sending') || 'Sending\u2026');
    fetch(hook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), redirect: 'follow' })
      .then(function () { form.reset(); say(form.getAttribute('data-sent') || 'Brief received'); })
      .catch(function () { say('That did not send. Please try again or email us.', true); })
      .then(function () { if (btn) btn.disabled = false; });
  });
})();
